import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { change, Field, reduxForm } from 'redux-form';
import { Button, ButtonToolbar, Card, CardBody, Col, Row } from 'reactstrap';
import { connect } from 'react-redux';


const required = value => value ? undefined : 'Required'
const renderField = ({ input, label, placeholder, type, meta: { touched, error, warning }, disabled }) => (
    <div className="form__form-group">
        <div className="form__form-group">
            <input
                {...input}
                  className="custom-placeholder"
                placeholder={placeholder}
                type={type}
                disabled={disabled}  // Add the disabled prop here
            />
            {touched && ((error && <span className="form__form-group-error"> {label} {error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
);

const AppVersionAddOrUpdate = ({ handleSubmit,appData ,dispatch}) => {

    useEffect(() => {
        dispatch(change('AppVersionAddOrUpdateForm', 'versionNo', appData?.versionNo));  
        dispatch(change('AppVersionAddOrUpdateForm', 'releaseNotes', appData?.releaseNotes));  
        dispatch(change('AppVersionAddOrUpdateForm', 'appReleaseId', appData?.appReleaseId));
    },[])
   
    return (
        <Card>
            <CardBody>
                <Col lg={12} md={12}>
                    <form className="form-animated" onSubmit={handleSubmit}>
                        <Row style={{ width: "100%" }}>

                            <Col lg={6} md={6}>
                                <div className="form__form-group">
                                    <span className="required_field">* </span>{" "}   <span className="form__form-group-label">App Version No.</span>
                                    <div className="form__form-group-field">
                                        <Field
                                            validate={[required]}
                                            name="versionNo"
                                            component={renderField}
                                            type="text"
                                            label="App Version No."
                                            placeholder="App Version No."

                                        />
                                    </div>
                                </div>
                            </Col>

                        </Row>
                        {/* <Row style={{ width: "100%" }}>
                            <Col lg={12} md={12}>
                                <div className="form__form-animated-group">
                                    <div className="form__form-group">
                                        <span className="required_field">* </span>{" "}
                                        <span className="form__form-animated-group-label">Rider Specific Question?</span>
                                        <div className="form__form-animated-group-field">
                                            <Field
                                                name="isRiderSpecificInformation"
                                                component={renderToggleButtonField}
                                                defaultChecked={faqData?.isRiderSpecificInformation}/>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row> */}
                        <div className="form__form-group">
                            <span className="required_field">* </span>{" "}<span className="form__form-group-label">release_notes</span>
                            <div className="form__form-group-field">
                                <Field validate={required} style={{ height: "100px" }}
                                    component={'textarea'} name="releaseNotes" type="textarea" placeholder="releaseNotes" />
                            </div>
                        </div>



                        <div className="form__OnboardingButton">
                            <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                                <Button color="primary" type="submit" className="account__btn">Submit</Button>
                            </ButtonToolbar>
                        </div>
                    </form>
                </Col>
            </CardBody>
        </Card>
    );
};


AppVersionAddOrUpdate.propTypes = {
    AppVersionAddOrUpdate: PropTypes.func.isRequired,
};


const mapStateToProps = () => {
    return { }
          
};


export default connect(mapStateToProps)(reduxForm({ form: 'AppVersionAddOrUpdateForm', enableReinitialize: true })(AppVersionAddOrUpdate))